module.exports = __webpack_public_path__ + "static/media/bike-image-02-03.eb8dd08c.png";